<template>
  <div class="renewals-list">
    <ul class="renewals-list__list">
      <transition-group name="list" tag="div">
        <li
          class="renewals-list__item flex align-center justify-between"
          v-for="(item, index) in visibleItems"
          :key="item.id || index"
        >
          <p class="renewals-list__title">
            {{ item.title }}
            <span class="renewals-list__date">{{ item.date }}</span>
          </p>
          <SmartLink class="renewals-list__link" :route="item.route">Переглянути</SmartLink>
        </li>
      </transition-group>
    </ul>
    <button
      v-if="hasMoreItems && !showAll"
      class="renewals-list__more"
      @click="showAllItems"
    >
      Показати ще
    </button>
    <button
      v-if="showAll && hasMoreItems"
      class="renewals-list__less"
      @click="showLessItems"
    >
      Приховати
    </button>
  </div>
</template>

<script>
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
      validator: (items) => {
        return items.every(item => item.id !== undefined || true);
      }
    },
    limit: {
      type: Number,
      default: 5,
    },
  },
  components: { SmartLink },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    visibleItems() {
      return this.showAll ? this.items : this.items.slice(0, this.limit);
    },
    hasMoreItems() {
      return this.items.length > this.limit;
    }
  },
  methods: {
    showAllItems() {
      this.showAll = true;
    },
    showLessItems() {
      this.showAll = false;
      this.$nextTick(() => {
        this.$el.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.renewals-list {
  &__list {
    overflow: hidden;
  }

  &__item {
    padding: 16px 0;
    transition: all 0.4s ease;

    &:last-child {
      padding-bottom: 0;
    }
  }

  &__title {
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
  }

  &__date {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #FF3B30;
  }

  &__link {
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 15px;
    border-bottom: 1px solid #09090B;

    &:hover {
      border-bottom: 1px solid transparent;
    }
  }

  &__more,
  &__less {
    position: absolute;
    right: 24px;
    bottom: 24px;
    display: inline-block;
    color: #858C95;
    font-weight: 500;
    line-height: 15px;
    border-bottom: 1px solid #858C95;
    margin-top: 24px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-bottom: 1px solid transparent;
    }
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s ease;
  }

  .list-enter-from,
  .list-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  .list-move {
    transition: transform 0.5s ease;
  }
}
</style>
